// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1t39u","buttons":"PendingPaymentAlert_buttons__Rk2rv"};